
import { CartContext } from '../../../providers/CartContext';
import { formatPrice } from "../../../lib/utils";

import PropTypes from 'prop-types';

function CheckoutItem(props) {

  const { item, quantity, priceUnit, price, itemName, maxValue, id, setValue } = props;

  const { comboProductPriceForSize } = React.useContext(CartContext);

  const IncrementItem = () => {
    if (quantity >= maxValue) {

    } else {
      //setQuantity(quantity + 1);
      setValue({ id: id, quantity: (quantity + 1) });
    }
  }

  const DecreaseItem = () => {
    //setQuantity(quantity - 1 );
    setValue({ id: id, quantity: (quantity - 1) });

    /*  if(quantity <= (min +1)) {

     }else {
         setState({ quantity: quantity - 1 });
       setValue({id:id,quantity: (quantity - 1 )});
     } */
  }
  /*  ToggleClick = () => {
     setState({ show: !show });
   } */

  const _itemOptions = (item) => {
    if (!item.selectedOptions || item.selectedOptions.length === 0) return <div className="item-options selected-options"></div>
    return (
      <div className="item-options  selected-options">
        {item.selectedOptions.map((opt) => {
          return (
            <div className="text-gray mb-0 space-between" key={"option_" + opt.id}>
              <span>{opt.group_name}:</span> <span>{opt.name}</span> <span>{formatPrice(opt.price * quantity)}</span>
            </div>
          )
        })}

      </div>
    )
  }

  const addonNameQuantity = (addon) => {
    if (addon.quantity > 1) {
      return <span>{addon.name} ({addon.quantity})</span>
    }
    return <span>{addon.name}</span>
  }

  const _itemAddons = (item) => {
    if (!item.selectedAddons || item.selectedAddons.length === 0) return <div className="item-options selected-addons"></div>
    return (
      <div className="item-options selected-addons">
        {item.selectedAddons.map((opt) => {
          return (
            <div className="text-gray mb-0 space-between" key={"option_" + opt.id}>
              {addonNameQuantity(opt)} <span>{formatPrice(opt.price * quantity)}</span>
            </div>
          )
        })}

      </div>
    )
  }

  const _itemCombos = (product) => {
    if (!product || product.type !== 'Combo') {
      return <></>
    }

    let chosenSize = product.chosenSize || product.size

    return (
      <div className="item-options selected-addons">
        {product.Combos && product.Combos.map((combo, index) => {

          return (
            <div className="text-gray mb-0 space-between" key={`combo_${index}`}>
              <span>{combo.selectedItem.name} </span> <span>{
              formatPrice(comboProductPriceForSize(combo.selectedItem, chosenSize, combo.multiplier))}</span>
            </div>
          )
        }

        )}
      </div>
    )
  }

  const _itemSize = (product) => {
    if (product.chosenSize && product.chosenSize !== '') {
      return (
        <div>
          <div className="text-gray mb-0 space-between" >
            <span>{product.chosenSize}</span>
          </div>
        </div>
      )
    }
    return <></>
  }

  //console.log("checkout Item", props.cartItem)

  if (setValue) {
    return (
      <div className="gold-members p-2 border-bottom">

        <div  >
          {props.image ?
            <img className={props.imageClass} src={props.image} alt={props.imageAlt}
            style={{ borderRadius: 5, width: "60%" }} />
            :
            <div className="mr-2"><i className="icofont-ui-press text-danger food-item" /></div>
          }
        </div>

        <div className="mb-4 space-between">
          <div className="">
            <p className="mt-1 mb-0 text-black">{itemName}</p>
          </div>

          {/* chosen size */}
          {_itemSize(props.cartItem)}

          <span className="count-number">
            <button type="button" className="btn-sm left dec btn btn-outline-secondary"
            onClick={DecreaseItem}  > <i className="icofont-minus" /> </button>
            <input className="count-number-input" type="text" value={quantity} readOnly />
            <button type="button" className="btn-sm right inc btn btn-outline-secondary"
            onClick={IncrementItem} > <i className="icofont icofont-plus" /> </button>
          </span>

          <span className="mb-0  ml-2">{formatPrice(price * quantity)}</span>

        </div>

        {/* combos */}
        {_itemCombos(props.cartItem)}

        {/* options */}
        {_itemOptions(props.cartItem)}


        {/* addons */}
        {_itemAddons(props.cartItem)}
      </div>
    );
  }

  return (
    <div className="gold-members p-2 border-bottom">
      <span className="  mb-0 float-right ml-2 checkoutitem-price">{formatPrice(price * quantity)}</span>
      <span className="count-number float-right">
        <input className="count-number-input" type="text" value={quantity} readOnly />
      </span>
      <div className="media">
        <div className="mr-2"><i className="icofont-ui-press text-danger food-item" /></div>
        <div className="media-body">
          <p className="mt-1 mb-0 text-black">{itemName}</p>
        </div>
      </div>

      {/* combos */}
      {_itemCombos()}

      {/* options */}
      {_itemOptions(props.cartItem)}


      {/* addons */}
      {_itemAddons(props.cartItem)}
    </div>
  );
}

CheckoutItem.propTypes = {
  itemName: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  priceUnit: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  quantity: PropTypes.number.isRequired,
  show: PropTypes.bool.isRequired,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  // setValue: PropTypes.func.isRequired  // if not set then this is on the thanks page
};
CheckoutItem.defaultProps = {
  show: true,
  priceUnit: '$'
}



export default CheckoutItem;